import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener las Familias de Repuesto creadas para clasificar correctamente.',
    'Tener las Marcas de Repuesto cargadas si querés asociar marca al repuesto.',
    'Tener cargados los depósitos y componentes para poder asociarlos a los repuestos.',
  ],
  tips: [
    'Usá el código del fabricante como referencia interna para facilitar la búsqueda.',
    'Completá la descripción con características clave: viscosidad, medida, especificación.',
    'Un repuesto bien cargado agiliza los requerimientos y los remitos del almacén.',
    'Los repuestos donde se especifiquen componentes o depósitos, podrán utilizarse en los repuestos recomendados de los equipos, y a su vez autocompletarse en las planillas de mantenimiento preventivo en las tareas que compartan dicho componente o depósito.',
    'Los repuestos marcados en "¿Se usa en el mantenimiento diario?" podrán autocompletarse en las planillas de lubricación y control de niveles.',
  ],
  nextSteps: [
    'Cargar stock inicial desde el módulo de Almacén.',
    'Los repuestos estarán disponibles para armar requerimientos y utilizarlos en las OTC.',
    'Cargar repuestos recomendados y capacidades de llenado en los equipos.',
    'Cargar los puntos de pedido para que nunca te quedes sin stock.',
  ],
};

const ConfiguracionRepuestos = () => (
  <ConfiguracionBase
    apiEndpoint="repuestos"
    titulo="Repuestos"
    descripcion="Inventario de repuestos"
    icon="fas fa-tools"
    compact
    help={HELP}
  />
);

export default ConfiguracionRepuestos;
